// extracted by mini-css-extract-plugin
module.exports = {"desktopButtonsContainer":"DesktopButtons_desktopButtonsContainer__pQVVH","iconContainer":"DesktopButtons_iconContainer__G6cyk","plusBadge":"DesktopButtons_plusBadge__csY_l"};